import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { getCategoryListForProject } from '../helpers/actions';
import { useTranslation } from 'react-i18next';

export const useFirstStep = (
    onLoaderChange: (value: boolean) => void,
    onFormChange: (name: string, value: string) => void
) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [optionsList, setOptionsList] = useState([]);
    const [selectedSelect, setSelectedSelect] = useState(null);

    useEffect(() => {
        getCategoryListForProject()
            .then((data) => {
                const list = data.map((item) => ({ title: item.name, value: item.id }));
                const defaultObjet = list[0];
                setOptionsList([
                    ...list,
                    {
                        title: t(
                            'useFirstStep.useEffect.getCategoryListForProject.setOptionsList.title'
                        ),
                        value: 'addCategory',
                    },
                ]);
                setSelectedSelect(defaultObjet);
                onFormChange('categoryId', defaultObjet.value);
            })
            .finally(() => {
                onLoaderChange(false);
            });
    }, []);

    const onChangeSelect = useCallback(
        (value: string) => {
            const findSelectItem = optionsList.find((item) => item.value === value);
            setSelectedSelect(findSelectItem);

            const categoryId = findSelectItem.value === 'addCategory' ? '' : findSelectItem.value;

            onFormChange('categoryId', categoryId);
        },
        [optionsList]
    );

    return { optionsList, onChangeSelect, selectedSelect };
};
